export const testListConstants = {
  TEST_LIST_LOADING: "TEST_LIST_LOADING",
  TEST_LIST_SUCCESS: "TEST_LIST_SUCCESS",
  TEST_LIST_FAILURE: "TEST_LIST_FAILURE",
};
